
function serialize(options) {
  return Object.keys(options).map((key) => (`${key}=${encodeURI(options[key])}`)).join('&');
}


export default serialize;



// WEBPACK FOOTER //
// ./src/utils/serialize.js